export const URL_BASE = process.env.REACT_APP_B2B_API;
export const URL_BASE_IMAGES = process.env.REACT_APP_BASE_URL_IMAGE;
//Carritos
export const CARRITO = "carritoB2BSDI";
export const CARRITOPROMO = "carritoPromosB2BSDI";
//cliente
export const VALIDATENIT = URL_BASE + "cliente/activate/nit";
export const VALIDATECODE = URL_BASE + "cliente/activate/codigo";
export const GETACTIVATE = URL_BASE + "negocios/activate";
export const GETNEGOCIOS = URL_BASE + "cliente/negocios";
export const UPDATEDATOS = URL_BASE + "register/user";
export const GETSUCRUSALES = URL_BASE + "cliente/sucursales";
export const GETPREGUNTAS = URL_BASE + "activate/preguntas/seguridad";
export const VALIDARPREGUNTAS = URL_BASE + "activate/validar/respuestas";
export const REGISTERCLIENT = URL_BASE + "register/user";
export const VALIDARLOGIN = URL_BASE + "Cliente";
export const GETCARRITO = URL_BASE + "catalogo/carrito";
//Mis credit
export const MICREDITO = URL_BASE + "cliente/credito";
export const SOLICITUDCREDITO = URL_BASE + "cliente/Solicitudcredito";

//CargaMasiva
export const GETINSTRUCCIONES = URL_BASE + "cargamasiva/instructivo";
export const UPLOADFILE = URL_BASE + "cargamasiva/upload";
export const SENDMAIL = URL_BASE + "cargamasiva/send";
export const CANCELARCARGA = URL_BASE + "cancelar/cargamasiva";

//catalogo
export const GETPRODUCTO = URL_BASE + "catalogo/productodetalle";
export const GETPRODUCTOSSUGERIDOSMASCOMPRADOS =
  URL_BASE + "catalogo/masComprados/sugeridos";
export const GETPRODUCTOSBUSCADOS = URL_BASE + "catalogo/buscador";
export const GETSUGERIDOS = URL_BASE + "catalogo/relacionados";

//Redime
export const GETVALIDACIONREDIME = URL_BASE + "catalogo/validar/redime";

//Prestamos
export const GETPRESTAMOS = URL_BASE + "Prestamos";

//home
export const GETHOME = URL_BASE + "configuracion/home";
export const GETCOMPONENTS = URL_BASE + "configuracion/home/componentes";
export const GETPRODUCTOS = URL_BASE + "producto/";

//Accesos Rapidos
export const GETACCESOSRAPIDOS = URL_BASE + "configuracion/home/accesos";

//inicio
export const GETPASOPASO = URL_BASE + "configuracion/home/paso_paso";

//imagenes
export const GETIMAGENES = URL_BASE + "wwwroot/Web/";

//banner
export const GETBANNER = URL_BASE + "configuracion/home/banner";

//Categorias y Marcas
export const GETCATEGORIAS = URL_BASE + "categorias";
export const GETMARCAS = URL_BASE + "marcas";

//Catalogo
export const GETPRODUCTOSCATALOGO = URL_BASE + "catalogo/producto";

//Orden
export const GETRECIBOPEDIDOS = URL_BASE + "ordenPedido";
export const GETRECIBO = URL_BASE + "orden";

//mis Datos
export const EDITPHOTO = URL_BASE + "MisDatos/Logo";
export const EDITNAME = URL_BASE + "MisDatos/Nombre";

//PreguntasFrecuentes
export const FAQS = URL_BASE + "Faqs";
export const ENVIARMENSAJE = URL_BASE + "Solicitud";

//pedido
export const NOVEDADPEDIDO = URL_BASE + "novedad/pedido";
export const NOVEDADPEDIDODETALLE = URL_BASE + "detalle/novedad/pedido";
export const FECHAENTREGA = URL_BASE + "FechaEntrega";
export const PEDIDOENCABEZADO = URL_BASE + "pedido/encabezado";
export const HISTORIALPEDIDODETALLE = URL_BASE + "historial/detalle";
export const HISTORIALPEDIDOS = URL_BASE + "historial";
export const HistorialPedidoAnterior = URL_BASE + "historial/anterior";
export const CANCELARPEDIDO = URL_BASE + "cancelar/pedido";
export const MODIFICARPEDIDO = URL_BASE + "modificacion/pedido";
export const PEDIRDENUEVO = URL_BASE + "pedirNuevamente";

export const VALIDARPEDIDO = URL_BASE + "validar/pedido";
export const VALIDARDESC = URL_BASE + "validar/descuento";

//Sucursal
export const CAMBIOSUCURSAL = URL_BASE + "cambio/sucursal";

//textos legales
export const TERMINOSLEGALES = URL_BASE + "Politica/";

//Formulario
export const URL_FORMULARIO = "https://www.postobon.com/formulario/rosita";

//Notificación

export const NOTIFICACIONES = URL_BASE + "Notificaciones";
export const MARCACIONOTIFICACIONES = URL_BASE + "marcacion";
